import { render } from "./UpdateBooking.vue?vue&type=template&id=3a581f3e"
import script from "./UpdateBooking.vue?vue&type=script&lang=js"
export * from "./UpdateBooking.vue?vue&type=script&lang=js"
script.render = render

export default script